<template>
  <div class="megatabs__panel-right">
    <panel-section>
      <div class="panel-section__info panel-section__info--left">
        <div class="panel-section__bg-img panel-section__bg-img--cool"></div>
        <header class="panel-section__header">
          <p class="panel-section__tab-name">
            SpaceManagement System
          </p>
          <h3 class="panel-section__title">
            CoolZone
          </h3>
          <p class="panel-section__subtitle">
            {{ pl ? 'Komora chłodziarki' : 'Fridge compartment' }}
          </p>
        </header>
        <p class="panel-section__description">
          {{ pl ? 'Sprytne rozwiązania w komorze chłodziarki pomogą Ci właściwie przechowywać produkty, dzięki czemu w Twojej kuchni nic się nie zmarnuje.' : 'The smart solutions in the fridge compartment will help you to store food properly; consequently, nothing will go to waste in your kitchen. ' }}
        </p>
      </div>
      <div class="feature-box feature-box--blue">
        <div class="feature-box__nav">
          <button class="feature-box__btn feature-box__btn--prev" @click.prevent="prevFeature('sectionOne')"></button>
          <button class="feature-box__btn feature-box__btn--next" @click.prevent="nextFeature('sectionOne')"></button>
        </div>

        <header class="feature-box__header">
          <div class="feature-box__icon feature-box__icon--large">
            <img
              :src="sectionOne[sectionOneActivePinIndex].icon"
              :alt="sectionOne[sectionOneActivePinIndex].title" />
          </div>
          <h4
            class="feature-box__title feature-box__title--red"
            v-html="sectionOne[sectionOneActivePinIndex].title">
          </h4>
        </header>
        <div
          v-if="sectionOne[sectionOneActivePinIndex].image === 'animated'"
          :class="[
            'feature-box__img',
            `function-image-animated-sectionone-${sectionOne[sectionOneActivePinIndex].id}
          `]">
        </div>
        <img
          v-else
          class="feature-box__img"
          :src="sectionOne[sectionOneActivePinIndex].image"
          :alt="sectionOne[sectionOneActivePinIndex].title">
        <p
          class="feature-box__description"
          v-html="sectionOne[sectionOneActivePinIndex].copy">
        </p>

      </div>
    </panel-section>

    <panel-section>
      <div class="panel-section__info panel-section__info--left">
        <div class="panel-section__bg-img panel-section__bg-img--adapt"></div>
        <header class="panel-section__header">
          <p class="panel-section__tab-name">
            SpaceManagement System
          </p>
          <h3 class="panel-section__title">
            AdaptZone
          </h3>
          <p class="panel-section__subtitle">
            {{ pl ? 'Szuflada' : 'Drawer' }}
          </p>
        </header>
        <p class="panel-section__description">
          {{ pl ? 'Przechowuj w szufladzie AdaptZone najbardziej wymagające produkty.' : 'Store the most sensitive food products in the AdaptZone drawer' }}
        </p>
      </div>
      <div class="feature-box feature-box--green">
        <div class="feature-box__nav">
          <button class="feature-box__btn feature-box__btn--prev" @click.prevent="prevFeature('sectionTwo')"></button>
          <button class="feature-box__btn feature-box__btn--next" @click.prevent="nextFeature('sectionTwo')"></button>
        </div>

        <header class="feature-box__header">
          <div class="feature-box__icon feature-box__icon--large">
            <img
              :src="sectionTwo[sectionTwoActivePinIndex].icon"
              :alt="sectionTwo[sectionTwoActivePinIndex].title" />
          </div>
          <h4
            class="feature-box__title feature-box__title--red"
            v-html="sectionTwo[sectionTwoActivePinIndex].title">
          </h4>
        </header>
        <div
          v-if="sectionTwo[sectionTwoActivePinIndex].image === 'animated'"
          :class="[
            'feature-box__img',
            `function-image-animated-sectiontwo-${sectionTwo[sectionTwoActivePinIndex].id}
          `]"
        ></div>
        <img
          v-else
          class="feature-box__img"
          :src="sectionTwo[sectionTwoActivePinIndex].image"
          :alt="sectionTwo[sectionTwoActivePinIndex].title">
        <p
          class="feature-box__description"
          v-html="sectionTwo[sectionTwoActivePinIndex].copy">
        </p>

      </div>
    </panel-section>

    <panel-section>
      <div class="panel-section__info panel-section__info--left">
        <div class="panel-section__bg-img panel-section__bg-img--freeze"></div>
        <header class="panel-section__header">
          <p class="panel-section__tab-name">
            SpaceManagement System
          </p>
          <h3 class="panel-section__title">
            FreezeZone
          </h3>
          <p class="panel-section__subtitle">
            {{ pl ? 'Szuflady zamrażarki' : 'Freezer drawers' }}
          </p>
        </header>
        <p class="panel-section__description">
          {{
            pl
            ? 'Ułatwienia już na pierwszy rzut oka! Otwierasz zamrażarkę i od razu wiesz, gdzie co jest – nie musisz wysuwać po kolei wszystkich szuflad i sprawdzać! Ikony nadrukowane na szufladach podpowiedzą, gdzie umieścić produkt. W wybranych modelach identyfikację produktów ułatwią też kolorowe szuflady.'
            : 'Convenience at first glance! You open the freezer and know right away where things are, without opening all the drawers to check! The icons printed on the drawers are hints of where to place specific products. In selected models, product identification is further enhanced by coloured drawers.'
          }}
        </p>
      </div>
      <div class="feature-box feature-box--darkblue">
        <div class="feature-box__nav">
          <button class="feature-box__btn feature-box__btn--prev" @click.prevent="prevFeature('sectionThree')"></button>
          <button class="feature-box__btn feature-box__btn--next" @click.prevent="nextFeature('sectionThree')"></button>
        </div>

        <header class="feature-box__header">
          <div class="feature-box__icon feature-box__icon--large" v-if="sectionThree[sectionThreeActivePinIndex].icon">
            <img
              :src="sectionThree[sectionThreeActivePinIndex].icon"
              :alt="sectionThree[sectionThreeActivePinIndex].title" />
          </div>
          <h4
            class="feature-box__title feature-box__title--red"
            v-html="sectionThree[sectionThreeActivePinIndex].title">
          </h4>
        </header>
        <div
          v-if="sectionThree[sectionThreeActivePinIndex].image === 'animated'"
          :class="[
            'feature-box__img',
            `function-image-animated-sectionthree-${sectionThree[sectionThreeActivePinIndex].id}
          `]"
        ></div>
        <img
          v-else
          class="feature-box__img"
          :src="sectionThree[sectionThreeActivePinIndex].image"
          :alt="sectionThree[sectionThreeActivePinIndex].title">
        <p
          class="feature-box__description"
          v-html="sectionThree[sectionThreeActivePinIndex].copy">
        </p>

      </div>
    </panel-section>
  </div>
</template>

<script>
import PanelSection from './PanelMobileSection';

export default {
  props: ["component_data"],
  components: {
    PanelSection,
  },
  data: () => ({
    sectionOneActivePinIndex: 0,
    sectionTwoActivePinIndex: 0,
    sectionThreeActivePinIndex: 0,
  }),
  computed: {
    sectionOne() {
      return this.component_data.functions['section-one'].filter(el => el.image);
    },
    sectionTwo() {
      return this.component_data.functions['section-two'].filter(el => el.image);
    },
    sectionThree() {
      return this.component_data.functions['section-three'].filter(el => el.image);
    },
  },
  methods: {
    prevFeature(section) {
      if (this[`${section}ActivePinIndex`] === 0) { // Pierwszy element
        this[`${section}ActivePinIndex`] = this[section].length - 1;
      } else {
        this[`${section}ActivePinIndex`]--;
      }
    },
    nextFeature(section) {
      if (this[`${section}ActivePinIndex`] === this[section].length - 1) { // Ostatni element
        this[`${section}ActivePinIndex`] = 0;
      } else {
        this[`${section}ActivePinIndex`]++;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.megatabs__panel-right {
  .panel-section {
    margin-bottom: 11vw;
  }
}

// SNACKBOX
.function-image-animated-sectionone-5 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  animation: snackBoxAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

// FLEXISHELF
.function-image-animated-sectionone-3 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  animation: flexiShelfAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

.function-image-animated-sectionone-6 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  animation: doorShelfAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

.function-image-animated-sectionone-1 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  animation: deskaSerowAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

@keyframes snackBoxAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  }
  30% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  }
  35% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox2.jpg");
  }
  65% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox2.jpg");
  }
  70% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox3.jpg");
  }
  95% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox3.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  }
}

@keyframes flexiShelfAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  }
  45% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  }
  55% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf2.jpg");
  }
  90% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf2.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  }
}

@keyframes doorShelfAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  }
  45% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  }
  55% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf2.jpg");
  }
  90% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf2.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  }
}

@keyframes deskaSerowAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  }
  45% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  }
  55% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow2.jpg");
  }
  90% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow2.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  }
}
</style>
